export default __webpack_public_path__ + "static/media/12_gallery.a31998c2.jpg";